export const ACCORDION_ACTION_NAMES = {
  TOGGLE_OPEN: 'ACCORDION_ACTION_NAMES__TOGGLE_OPEN',
};

export const toggleOpen = (key: string) => ({
  type: ACCORDION_ACTION_NAMES.TOGGLE_OPEN,
  payload: key,
});
